import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setGetRezyme} from '../../store/thunk/setGetRezyme';
import TableCasino from './block/table';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {ReactComponent as ArrowDown} from '../../../../../@casino/img/down-arrow.svg';
import {columns, useStyles, getRows} from './helpers';
import { setGetBet } from '../../store/thunk/setGetBet';

const BlockRezym = ({id}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [rezyme, setRezyme] = React.useState(false);

    React.useEffect(() => {
        if (rezyme) {
            dispatch(setGetBet({
                id,
                page: 1,
                rowsPerPage: 5
            }))
        }
    }, [id, rezyme]);

    const rezymeArr = useSelector(state => state.users.bet);
    const rows = React.useMemo(() => getRows(rezymeArr.data), [rezymeArr]);
    
    return (
        <div>
            <div 
                className={classes.wrapTitle}
                onClick={() => {
                    setRezyme(!rezyme)
                }}
            >
                <span
                    className={classes.title}
                >
                    История ставок
                </span>
                {
                    !rezyme && 
                    <ArrowRight className={classes.arrow}/>
                }
                {
                    rezyme && 
                    <ArrowDown className={classes.arrow}/> 
                }   
            </div>
            <div>
                {
                    rezyme && id &&
                    <TableCasino 
                        allPage={rezymeArr.count}
                        pagination
                        width={1280}
                        perPage={5}
                        columns={columns}
                        rows={rows}
                        changePage={(v) => dispatch(setGetBet({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                        changeRowsPerPage={(v) => dispatch(setGetBet({
                            page: 1,
                            rowsPerPage: v.rowsPerPage,
                            id
                        }))}
                    /> 
                }
            </div>       
        </div>
    )
}

export default BlockRezym;